import { ShopifyEntityKind } from "@intelligems/ig-types";

import { ShopifyItemPickerItem } from "@src/components/MainApp/ShopifyItemPicker/ShopifyItemPicker";

/** The product picker's store key for this dialog, so no other picker's open state reads as ours. */
export const AI_USER_INPUT_PRODUCT_PICKER_TYPE = "aiUserInput";

/** One picked catalog item: `id` is what the agent reads, `label` what the merchant sees. */
export type ShopifyEntityPick = ShopifyItemPickerItem;

/**
 * Merchant-facing words for each entity kind, shared by the survey card's
 * button copy and the picker dialogs' titles.
 */
export const SHOPIFY_ENTITY_COPY: Record<
  ShopifyEntityKind,
  {
    singular: string;
    plural: string;
    /** The dialog title and the card's "Choose …" button. */
    choose: string;
    searchPlaceholder: string;
  }
> = {
  product: {
    singular: "product",
    plural: "products",
    choose: "Choose products",
    searchPlaceholder: "Search products",
  },
  collection: {
    singular: "collection",
    plural: "collections",
    choose: "Choose collections",
    searchPlaceholder: "Search collections",
  },
  tag: {
    singular: "product tag",
    plural: "product tags",
    choose: "Choose product tags",
    searchPlaceholder: "Search product tags",
  },
  vendor: {
    singular: "vendor",
    plural: "vendors",
    choose: "Choose vendors",
    searchPlaceholder: "Search vendors",
  },
  product_type: {
    singular: "product type",
    plural: "product types",
    choose: "Choose product types",
    searchPlaceholder: "Search product types",
  },
};

/** The button and title copy for a pick, singular when only one item is the answer. */
export const shopifyEntityChooseLabel = (
  entity: ShopifyEntityKind,
  multiSelect: boolean
): string => {
  const copy = SHOPIFY_ENTITY_COPY[entity];
  return multiSelect ? copy.choose : `Choose a ${copy.singular}`;
};
